import { lazy } from "react";
export const feature = {
    id: "global-entities",
    nav: [
        {
            label: "Global Entities",
            icon: "Boxes",
            path: "/global-entities",
            group: "Platform",
            order: 1,
            actions: ["view", "create", "edit", "delete"],
            apiPaths: [
                "/global-entities",
                "/global-entities/*",
                "/api/v1/global-entities",
                "/api/v1/global-entities/*",
            ],
        },
        {
            label: "Intelligence",
            icon: "Brain",
            path: "/intelligence",
            group: "Platform",
            order: 2,
            actions: ["view"],
            apiPaths: ["/platform/intelligence"],
        },
        {
            label: "Sites",
            icon: "Globe",
            path: "/sites",
            group: "Platform",
            order: 3,
            actions: ["view", "create", "edit", "delete"],
            apiPaths: ["/sites", "/sites/*", "/deploy"],
        },
        {
            label: "Niche Fallback",
            icon: "Shuffle",
            path: "/niche-fallback",
            group: "Platform",
            order: 4,
            actions: ["view"],
            apiPaths: ["/global-entities/niche-fallback-summary"],
        },
        {
            label: "Platforms",
            icon: "Layers",
            path: "/platforms",
            group: "Platform",
            order: 5,
            actions: ["view", "create", "edit"],
            apiPaths: [
                "/global-entities/partner-platforms",
                "/global-entities/partner-platforms/*",
                "/global-entities/product-platforms",
                "/global-entities/product-platforms/*",
            ],
        },
    ],
    routes: [
        {
            path: "/global-entities",
            component: lazy(() => import("./pages/GlobalEntities.js").then((m) => ({
                default: m.GlobalEntities,
            }))),
        },
        {
            path: "/global-entities/new",
            component: lazy(() => import("./pages/GlobalEntityCreate.js").then((m) => ({
                default: m.GlobalEntityCreate,
            }))),
        },
        {
            path: "/global-entities/:id",
            component: lazy(() => import("./pages/GlobalEntityDetail.js").then((m) => ({
                default: m.GlobalEntityDetail,
            }))),
        },
        {
            path: "/intelligence",
            component: lazy(() => import("./pages/GlobalIntelligence.js").then((m) => ({
                default: m.GlobalIntelligence,
            }))),
        },
        {
            path: "/sites",
            component: lazy(() => import("./pages/Sites.js").then((m) => ({ default: m.Sites }))),
        },
        {
            path: "/sites/:id/edit",
            component: lazy(() => import("./pages/Sites.js").then((m) => ({ default: m.SiteEdit }))),
        },
        {
            path: "/niche-fallback",
            component: lazy(() => import("./pages/NicheFallback.js").then((m) => ({ default: m.NicheFallback }))),
        },
        {
            path: "/platforms",
            component: lazy(() => import("./pages/Platforms.js").then((m) => ({ default: m.Platforms }))),
        },
    ],
};
//# sourceMappingURL=index.js.map